import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        cursor: "pointer",
        width: "100%",
    },
    header: {
        padding: "0.75rem 1rem",
        gap: "0.5rem",
        backgroundColor: theme.colors.gray[0],
        color: theme.colors.gray[7],
        display: "flex",
        flexDirection: "column",
    },
    firstLine: {
        padding: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "0.5rem",
    },
    headerIcon: {
        color: theme.colors.gray[7],
        width: "1rem",
        height: "1rem",
    },
    headerTitle: {
        all: "unset",
        paddingRight: "1rem",
        color: theme.colors.gray[9],
        fontSize: "1rem",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "1.25rem",
    },
    secondLine: {
        width: "100%",
        color: theme.colors.gray[7],
        fontSize: "0.75rem",
    },
    body: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: "0.75rem",

        "&:last-child": {
            marginBottom: "0.75rem",
        },
    },
    footer: {
        borderTop: `1px solid ${theme.colors.gray[1]}`,
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        padding: "0.5rem 0.75rem",

        color: theme.colors.gray[7],
        fontSize: "0.6875rem",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",

        "&& svg": {
            width: "0.875rem",
            height: "0.875rem",
        },
    },
}))
